export default __webpack_public_path__ + "static/media/dr-warood.7b7ab418.jpg";